module.exports = __webpack_public_path__ + "img/partner05.2c1bf580.png";